import {
  Box,
  Button,
  CircularProgress,
  Container,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Xs from "../../../components/containers/Xs";
import HeaderSignOut from "../../../components/headers/HeaderSignOut";
import { API_URL } from "../../../consts/ApiUrl";
import UserInfoTab from "./UserInfoTab";
import VonageInfoTab from "./VonageInfoTab";

const UserInfoUpdatePage: FC = () => {
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [userData, setUserData] = useState<Record<string, string> | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    const loginId = sessionStorage.getItem("loginId");
    const fetchUserData = async () => {
      try {
        const idToken = sessionStorage.getItem("idToken") || "";
        const headers: Record<string, string> = {
          "Content-Type": "application/json",
          Authentication: idToken,
        };
        if (API_URL.USER.includes("ngrok-free.dev")) {
          headers["ngrok-skip-browser-warning"] = "true";
        }
        const response = await fetch(`${API_URL.USER}?name=${loginId}`, {
          method: "GET",
          headers,
        });
        if (!response.ok) {
          if (response.status === 401) {
            navigate("/signin");
          } else {
            navigate("/error");
          }
          return;
        }
        const data = await response.json();
        if (data?.results?.[0]) {
          setUserData(data.results[0]);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        navigate("/error");
      } finally {
        setIsLoading(false);
      }
    };

    if (loginId) {
      fetchUserData();
    } else {
      setIsLoading(false);
    }
  }, [navigate]);

  return (
    <>
      <HeaderSignOut />
      <Container maxWidth="xl">
        <Box mt={10} textAlign="center">
          <Typography variant="h4" gutterBottom>
            情報更新
          </Typography>
        </Box>

        <Box mt={4} display="flex" justifyContent="center">
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              centered
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="ユーザ情報" />
              <Tab label="Vonage情報" />
            </Tabs>
          )}
        </Box>
      </Container>
      <Container maxWidth="lg">
        <Box mt={7} mb={2} display="flex" justifyContent="center">
          {isLoading ? (
            <Typography>データを読み込んでいます...</Typography>
          ) : userData ? (
            <>
              {tabIndex === 0 && <UserInfoTab userData={userData} />}
              {tabIndex === 1 && <VonageInfoTab userData={userData} />}
            </>
          ) : (
            <Typography>データの取得に失敗しました。</Typography>
          )}
        </Box>
      </Container>
      <Xs>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={() => navigate("/menu")}
          >
            戻る
          </Button>
        </Box>
      </Xs>
    </>
  );
};

export default UserInfoUpdatePage;
